import React from 'react'
import { motion } from 'framer-motion'

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } }
};

const Skills = () => {
    const skillCategories = [
        { title: "Languages & Core", skills: ["Python", "JavaScript", "C", "Java", "DSA"] },
        { title: "Frontend", skills: ["HTML5", "CSS3", "React.js", "Redux", "Tailwind", "Bootstrap"] },
        { title: "Backend", skills: ["Node.js", "Express.js", "REST API", "JWT", "Bcrypt"] },
        { title: "Databases", skills: ["MongoDB", "MySQL", "DBMS", "SQLite"] },
        { title: "Tools", skills: ["Git/GitHub", "Firebase", "Postman", "Vercel", "Render"] }
    ];

    return (
        <>
            <motion.div 
                className="ed-skl-card"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
            >
                <h2 className='px-4 mb-3'>Technical Skills</h2>
                {skillCategories.map((category, index) => (
                    <div key={index} className="px-4 mb-3">
                        <h4 style={{fontSize: "1.6rem", color: "var(--main-text-color)"}}>{category.title}</h4>
                        <motion.div 
                            className="skill-box" 
                            style={{paddingTop: "0.5rem"}}
                            variants={containerVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                        >
                            {category.skills.map((skill, i) => (
                                <motion.span key={i} variants={itemVariants} className='skill' style={{margin: "0.5rem", padding: "0.5rem 1rem", fontSize: "1.3rem"}}>{skill}</motion.span>
                            ))}
                        </motion.div>
                    </div>
                ))}
            </motion.div>
        </>
    )
}

export default Skills